<template>

<!-- Modal -->
<div class="modal" id="modalEditHeader" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div style="background-color:#FFCC00" class="modal-header">
        <h4 class="modal-title" id="staticBackdropLabel">
            <i  class="fas fa-edit mr-2" aria-hidden="true"></i>
           <strong> MODIFICA DOCUMENTO </strong></h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form id="formMain" v-on:submit.prevent="submit()" >
                
                <div class="form-group">
                
                <supplier-select :key="refresh"  v-bind:isActive="true" v-bind:Id="doc.supplierId" @update="setSupplierId"></supplier-select>
                <label for="doc_type"><strong>Tipo documento</strong></label>
                <select required v-model="doc.typeId" class="form-control bold" id="doc_type">
                    <option value="1">Fattura</option>
                    <option value="2">DDT</option>
                </select>
                </div>
                <div class="form-group">
                  <label for="number_doc"><strong>Numero documento</strong></label>
                  <input v-model="doc.number" type="text" class="form-control bold" placeholder="" name="number_doc" id = "number_doc" required>
                </div>
                <div class="form-group">
                  <label for="date_doc"><strong>Data documento</strong></label>
                  <input required v-model="doc.date" type="date" class="form-control bold" placeholder="" name="date_doc" id = "date_doc">
                </div>
                <!--
                <div class="form-group">
                  <label for="number_doc"><strong>Sconto documento</strong></label>
                  <input v-model="doc.discount" type="text" class="form-control bold" placeholder="" name="number_doc" id = "number_doc" required>
                </div>
                -->

        
                <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>   
            <button type="submit"  class="btn btn-primary float-right mt-2 mb-2">
              <i class="fas fa-edit mr-2" aria-hidden="true"></i>
              MODIFICA
            <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>       
      </form>

      
      </div>
      
      
      <div v-if="1==0" class="modal-footer">
       
         
        
           <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>-->
        
      </div>
    </div>
  </div>
</div>


</template>
<script>


import api              from '@/api';
import alertBox         from '@/components/common/AlertBox.vue';
import supplierSelect        from '@/components/common/SupplierSelect.vue' 

export default {
  
  components: {alertBox,supplierSelect
  
  },  
  props: ['documentId'],
 
 data () {
    return {
      
      doc             : {},
      alert           : false,
      spinner         : false,
      refresh         : 0,
      
     
      msg             : {
          
         title : '',
         body  : '',
         type  : 0
      }
      
      

    }
  },

computed: 
  {
   
   
  },
mounted()
{   
    
   
},
created()
{ 
  if(this.documentId>0)
  {
    this.getData()
  }  
},

methods: 
{
    setSupplierId(supplierId)
    {
      this.doc.supplierId = supplierId
      
    },
    async getData()
    {
       
        this.msg.title = ''
        var data = {'documentId' : this.documentId}
        var sp   = {'sp'         : 'spDocumentHeader'}
        var json = Object.assign(data, sp);
       
        this.spinner = true
        await api.post(json).then(res => {
                   
          if(res.status == 200)
            {
              this.doc = res.data.recordsets[0][0] 
              this.refresh++
            }
           else if(res.status == 500)
           {
                                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1
                    
           } 
           else
            {
                             
              this.msg.title =  'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1               
                 
            } 
          
          }).catch(err => {
                           
              this.msg.title =  'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                 
              
          }).finally(() => {
              this.spinner = false
        });


	},
  
   
        
  async submit() 
  {
    this.msg.title = ''
    this.spinner = true
    var data  = {'documentId':this.documentId,'number':this.doc.number,'date':this.doc.date,'typeId':this.doc.typeId,'supplierId':this.doc.supplierId,'stockMovementId':this.doc.stockMovementId}       
    var sp    = {'sp':'spUpdateDocumentHeader'}
    var json  = Object.assign(data, sp);

    await api.post(json).then(res => {
          
          if(res.status == 200)
            {
              if(res.data.recordsets[0][0].documentId == 0)
              {
                this.msg.title = 'ATTENZIONE'
                this.msg.body = 'DOCUMENTO FORNITORE DUPLICATO.'
                this.msg.type = 1
              }
              else
              {
                console.log('Document updated ! ')
                this.$emit('update',this.doc)    
              }
              
            }
           else if(res.status==500)
           {
                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                
                    
           } 
           else
            {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1 
            } 
          
          }).catch(err => {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1 
              
          }).finally(() => {
          this.spinner = false
        });



	}
  
      
}
    
}    
</script>

<style scoped>

 
.bold {
  font-weight: bolder;
}

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}


</style>